import React, { useRef } from 'react';
var VeltNotificationsPanelContentAll = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-content-all", { ref: ref }, children));
};
export default VeltNotificationsPanelContentAll;
